/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateIntakeScenarioRequest } from '../models/CreateIntakeScenarioRequest';
import type { CreateIntakeScenarioV2Request } from '../models/CreateIntakeScenarioV2Request';
import type { HousingApplication } from '../models/HousingApplication';
import type { HousingIntakeScenario } from '../models/HousingIntakeScenario';
import type { HousingIntakeScenarioDto } from '../models/HousingIntakeScenarioDto';
import type { HousingIntakeScenarioStatus } from '../models/HousingIntakeScenarioStatus';
import type { HousingIntakeScenarioTeamMember } from '../models/HousingIntakeScenarioTeamMember';
import type { HousingIntakeScenarioWaitlistEntry } from '../models/HousingIntakeScenarioWaitlistEntry';
import type { HousingIntakeScenarioWaitlistResponseDto } from '../models/HousingIntakeScenarioWaitlistResponseDto';
import type { IntakeScenarioConfiguration } from '../models/IntakeScenarioConfiguration';
import type { ScenarioWorkflowDto } from '../models/ScenarioWorkflowDto';
import type { SearchHousingIntakeScenariosResponseDto } from '../models/SearchHousingIntakeScenariosResponseDto';
import type { TeamMemberEntry } from '../models/TeamMemberEntry';
import type { VacancyStats } from '../models/VacancyStats';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingIntakeScenarioService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the configuration for intake scenarios.
     * @returns IntakeScenarioConfiguration OK
     * @throws ApiError
     */
    public getIntakeScenarioConfiguration(): CancelablePromise<IntakeScenarioConfiguration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/GetIntakeScenarioConfiguration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a list of all intake scenarios.
     * @param includeArchived true to include the archived scenarios.
     * @returns HousingIntakeScenarioDto OK
     * @throws ApiError
     */
    public getAllHousingIntakeScenarios(
        includeArchived: boolean = false,
    ): CancelablePromise<Array<HousingIntakeScenarioDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/GetAllHousingIntakeScenarios',
            query: {
                'includeArchived': includeArchived,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * "Vacancy Management" widget data for the Contact Activities Dashboard: the current
     * user's own intake throughput this month (1st → today) compared with all of last
     * month, derived from the scenario action log (Compliance.Module.Housing.DbModels.HousingIntakeScenarioLog)
     * filtered to actions the user performed. Scoped to the user across all orgs.
     * Scenarios Worked = distinct scenarios the user acted on (from logs).
     * Offers Created/Accepted/Rejected = "Offer Form" workflows by CreatedAt / UpdatedAt.
     * No Offers / Strikes / 3 Strikes = workflow counts for the respective form definitions.
     * Housed = HousingApplications with Status=Housed, bucketed by DateHoused.
     * @param targetUserGuid
     * @returns VacancyStats OK
     * @throws ApiError
     */
    public getVacancyStats(
        targetUserGuid?: string,
    ): CancelablePromise<VacancyStats> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/GetVacancyStats',
            query: {
                'targetUserGuid': targetUserGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Paginated, server-side search/filter endpoint for intake scenarios.
     * Supports text search, quick-filter presets (mine / myOrg / all / custom),
     * status filtering, and pagination.
     * @param search Free-text search against scenario name and building name.
     * @param quickFilter Quick-filter preset. "mine" = created by the calling user,
     * "myOrg" = orgs the calling user has roles in,
     * "all" = no ownership filter,
     * "custom" = use Compliance.Module.Housing.Dtos.SearchHousingIntakeScenariosRequestDto.HousingOrgGuid and/or Compliance.Module.Housing.Dtos.SearchHousingIntakeScenariosRequestDto.CreatedByGuid.
     * @param housingOrgGuid Filter by housing org (used when QuickFilter is "custom").
     * @param createdByGuid Filter by scenario creator (used when QuickFilter is "custom").
     * @param statuses Statuses to include. When empty or null, no status filter is applied.
     * Archived scenarios are controlled by Compliance.Module.Housing.Dtos.SearchHousingIntakeScenariosRequestDto.IncludeArchived.
     * @param includeArchived Whether to include archived scenarios.
     * @param ignoreFilters When true, only the text search is applied and all other filters are ignored.
     * Matches the "Search All" UX pattern.
     * @param pageNumber
     * @param pageSize
     * @returns SearchHousingIntakeScenariosResponseDto OK
     * @throws ApiError
     */
    public searchHousingIntakeScenarios(
        search?: string,
        quickFilter?: string,
        housingOrgGuid?: string,
        createdByGuid?: string,
        statuses?: Array<HousingIntakeScenarioStatus>,
        includeArchived?: boolean,
        ignoreFilters?: boolean,
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<SearchHousingIntakeScenariosResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/SearchHousingIntakeScenarios',
            query: {
                'Search': search,
                'QuickFilter': quickFilter,
                'HousingOrgGuid': housingOrgGuid,
                'CreatedByGuid': createdByGuid,
                'Statuses': statuses,
                'IncludeArchived': includeArchived,
                'IgnoreFilters': ignoreFilters,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single intake scenario by its guid.
     * @param housingIntakeScenarioGuid The guid of the scenario to get.
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public getHousingIntakeScenario(
        housingIntakeScenarioGuid: string,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/GetHousingIntakeScenario',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new intake scenario.
     * @param requestBody The request to create a new intake scenario.
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public createHousingIntakeScenario(
        requestBody?: CreateIntakeScenarioRequest,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/CreateHousingIntakeScenario',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * V2 create endpoint: creates a named scenario in Draft status with scenario-level
     * dimensions (Sector, Category, UnitType, Accessible), one or more target buildings,
     * and N vacancy rows keyed by (building, dateAvailable). The legacy
     * M:Compliance.Module.Housing.Controllers.HousingIntakeScenarioController.CreateHousingIntakeScenario(Compliance.Module.Housing.Dtos.CreateIntakeScenarioRequest) endpoint above is unchanged and continues
     * to serve the original IntakeOffer flow.
     * @param requestBody
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public createHousingIntakeScenarioV2(
        requestBody?: CreateIntakeScenarioV2Request,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/CreateHousingIntakeScenarioV2',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * V2 update endpoint: replaces the editable fields of a scenario and its vacancies.
     * Draft scenarios support a full update (all fields). Open scenarios support a partial
     * update restricted to name, total working contacts, and vacancies. Vacancies are synced by
     * Compliance.Module.Housing.DbModels.HousingIntakeScenarioVacancy.HousingIntakeScenarioVacancyGuid identity:
     * an entry with a guid updates that row in place, an entry without one inserts a new
     * row, and an existing row omitted from the payload is deleted (409 if processed
     * applications reference it). Used by the Vacancy Management 2.0 setup drawer.
     * @param housingIntakeScenarioGuid
     * @param requestBody
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public updateHousingIntakeScenarioV2(
        housingIntakeScenarioGuid: string,
        requestBody?: CreateIntakeScenarioV2Request,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/UpdateHousingIntakeScenarioV2',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * V2 activate endpoint: flips a Draft scenario to Open and snapshots the initial
     * matched-applicant list as Compliance.Module.Housing.DbModels.HousingIntakeScenarioProcessedApplication
     * rows with frozen score and position. Corresponds to the "Save and Generate List"
     * action in the Vacancy Management 2.0 drawer.
     * @param housingIntakeScenarioGuid The guid of the scenario to activate.
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public activateHousingIntakeScenarioV2(
        housingIntakeScenarioGuid: string,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/ActivateHousingIntakeScenarioV2',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Cancel an application that has reached the 3rd-strike per-scenario status. Only
     * succeeds when the processed-application entry status is
     * Compliance.Module.Housing.Enums.HousingIntakeScenarioProcessedApplicationStatus.ThirdStrike. Flips
     * the overall Compliance.Module.Housing.DbModels.HousingApplicationStatus to Cancelled.
     * @param housingIntakeScenarioGuid The guid of the scenario.
     * @param housingApplicationGuid The guid of the application to cancel.
     * @returns HousingApplication OK
     * @throws ApiError
     */
    public cancelApplication(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<HousingApplication> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/CancelApplication',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the current waitlist of housing applications for a intake scenario.
     * @param housingIntakeScenarioGuid The guid of the intake scenario to get waitlist for.
     * @param pageNumber
     * @param pageSize
     * @returns HousingIntakeScenarioWaitlistResponseDto OK
     * @throws ApiError
     */
    public getHousingIntakeScenarioWaitlist(
        housingIntakeScenarioGuid: string,
        pageNumber: number = 1,
        pageSize: number = 50,
    ): CancelablePromise<HousingIntakeScenarioWaitlistResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/GetHousingIntakeScenarioWaitlist',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single waitlist entry for one application in a scenario.
     * @param housingIntakeScenarioGuid
     * @param housingApplicationGuid
     * @returns HousingIntakeScenarioWaitlistEntry OK
     * @throws ApiError
     */
    public getSingleWaitlistEntry(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<HousingIntakeScenarioWaitlistEntry> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/GetSingleWaitlistEntry/{housingApplicationGuid}',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update a housing intake scenario by its guid.
     * @param housingIntakeScenarioGuid The guid of the intake scenario.
     * @param requestBody The updated scenario.
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public updateHousingIntakeScenario(
        housingIntakeScenarioGuid: string,
        requestBody?: HousingIntakeScenario,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/UpdateHousingIntakeScenario',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a housing intake scenario by its Guid.
     * @param housingIntakeScenarioGuid The id of the housing intake scenario
     * @returns any OK
     * @throws ApiError
     */
    public deleteHousingIntakeScenario(
        housingIntakeScenarioGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/DeleteHousingIntakeScenario',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @deprecated
     * Start intake for an application on a scenario. The applicant moves to
     * LockedInterviewing status and an Intake Process workflow is created. Vacancy
     * binding is deferred to M:Compliance.Module.Housing.Controllers.HousingIntakeScenarioController.ExtendOffer(System.Guid,System.Guid,System.Guid).
     * @param housingIntakeScenarioGuid The guid of the scenario.
     * @param housingApplicationGuid The guid of the application to start intaking.
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public startIntake(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/StartIntake',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Close an open or migrated scenario. Returns Intake applicants to the
     * waitlist and deletes pending form responses on linked workflows.
     * Blocked if any applicant is locked for interview (Interviewing) or has an offer in progress (OfferInProgress).
     * @param housingIntakeScenarioGuid
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public closeHousingIntakeScenario(
        housingIntakeScenarioGuid: string,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/CloseHousingIntakeScenario',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Lock an application for interview processing without creating a workflow.
     * Updates the processed application status and the housing application status.
     * @param housingIntakeScenarioGuid
     * @param housingApplicationGuid
     * @returns any OK
     * @throws ApiError
     */
    public lockForInterview(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/LockForInterview',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Mark an application as housed. Direct status update, no workflow.
     * @param housingIntakeScenarioGuid
     * @param housingApplicationGuid
     * @returns any OK
     * @throws ApiError
     */
    public markHoused(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/MarkHoused',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Undo a housed status. Reverts the application status back to OfferAccepted
     * and clears the housed date.
     * @param housingIntakeScenarioGuid
     * @param housingApplicationGuid
     * @returns any OK
     * @throws ApiError
     */
    public undoHoused(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/UndoHoused',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all workflows linked to a scenario + application via the join table.
     * @param housingIntakeScenarioGuid
     * @param housingApplicationGuid
     * @returns ScenarioWorkflowDto OK
     * @throws ApiError
     */
    public getScenarioWorkflows(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<Array<ScenarioWorkflowDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/GetScenarioWorkflows',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get ALL vacancy-management workflows for an application across every scenario,
     * plus any legacy workflows (definition name "Legacy: Offer" or "Legacy: No Offer")
     * linked to the same entity.
     * @param orgGuid
     * @param applicationGuid
     * @param entityGuid
     * @returns ScenarioWorkflowDto OK
     * @throws ApiError
     */
    public getAllScenarioWorkflowsForApplication(
        orgGuid: string,
        applicationGuid: string,
        entityGuid: string,
    ): CancelablePromise<Array<ScenarioWorkflowDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingIntakeScenario/{orgGuid}/application/{applicationGuid}/entity/{entityGuid}/GetAllScenarioWorkflowsForApplication',
            path: {
                'orgGuid': orgGuid,
                'applicationGuid': applicationGuid,
                'entityGuid': entityGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Replace the team members (Owner/Member) for a scenario. Flagged rows are not affected.
     * At least one Owner is required.
     * @param housingIntakeScenarioGuid
     * @param requestBody
     * @returns HousingIntakeScenarioTeamMember OK
     * @throws ApiError
     */
    public updateTeamMembers(
        housingIntakeScenarioGuid: string,
        requestBody?: Array<TeamMemberEntry>,
    ): CancelablePromise<Array<HousingIntakeScenarioTeamMember>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/UpdateTeamMembers',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Toggle the calling user's flag (bookmark) on a scenario.
     * @param housingIntakeScenarioGuid
     * @returns any OK
     * @throws ApiError
     */
    public toggleFlag(
        housingIntakeScenarioGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/ToggleFlag',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Extend an offer to an applicant for a specific vacancy. Binds the
     * Compliance.Module.Housing.DbModels.HousingIntakeScenarioProcessedApplication.HousingIntakeScenarioVacancyGuid
     * and transitions the entry to Compliance.Module.Housing.Enums.HousingIntakeScenarioProcessedApplicationStatus.OfferInProgress.
     * The target vacancy must be one of the applicant's matched vacancies and must have
     * remaining capacity.
     * @param housingIntakeScenarioGuid
     * @param housingApplicationGuid
     * @param housingIntakeScenarioVacancyGuid
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public extendOffer(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
        housingIntakeScenarioVacancyGuid?: string,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/ExtendOffer',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            query: {
                'housingIntakeScenarioVacancyGuid': housingIntakeScenarioVacancyGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Remove the intake lock for an application on a scenario, resetting its
     * processed status back to the waitlist.
     * @param housingIntakeScenarioGuid The guid of the scenario.
     * @param housingApplicationGuid The guid of the application to unlock.
     * @returns HousingIntakeScenario OK
     * @throws ApiError
     */
    public removeLock(
        housingIntakeScenarioGuid: string,
        housingApplicationGuid: string,
    ): CancelablePromise<HousingIntakeScenario> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingIntakeScenario/{housingIntakeScenarioGuid}/{housingApplicationGuid}/RemoveLock',
            path: {
                'housingIntakeScenarioGuid': housingIntakeScenarioGuid,
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
